import { createContext } from 'react';
import Repositories from '../repositories/repositories'

const DataContext = createContext(new Repositories())

export default DataContext;